export interface UserDetails {
    user_login: string;
    user_pwd: string;
}

export const defaultUserDetails: UserDetails = {
    user_login: '',
    user_pwd: ''
};
 